import { SupportingContent } from "@wayflyer/flyui";
import { useIntl } from "react-intl";
import { useInviteModalActions } from "shared-ui";

import { COMMON_MESSAGES } from "../../common-messages";

import { MESSAGES } from "./message-definitions";

export const BankStatementUploadSecondaryContent = (): UIElement => {
  const intl = useIntl();
  const { openInviteModal } = useInviteModalActions();
  const openInviteModalHandler = () => {
    openInviteModal();
  };

  return (
    <>
      <SupportingContent
        faqItems={[
          {
            question: intl.formatMessage(MESSAGES.bankStatementSecondaryContentHeading),
            answer: intl.formatMessage(MESSAGES.bankStatementSecondaryContentText),
          },
        ]}
        supportingLinks={{
          heading: intl.formatMessage({
            id: "funding-application: need help",
            defaultMessage: "Need help?",
          }),
          links: [
            {
              linkText: intl.formatMessage({
                id: "funding-application: invite team member to help upload",
                defaultMessage: "Invite a team member to help upload statements",
              }),
              onClick: openInviteModalHandler,
            },
            {
              external: true,
              url: "https://help-center.wayflyer.com/en/collections/156738-banking-connections",
              linkText: intl.formatMessage({
                id: "funding-application: learn more in our health center",
                defaultMessage: "Learn more in our Help Center",
              }),
            },
          ],
        }}
        securityInfo={{
          label: intl.formatMessage({
            id: "funding-application: data security statement",
            defaultMessage: "Your data is securely stored in encrypted databases",
          }),
          link: {
            external: true,
            linkText: intl.formatMessage(COMMON_MESSAGES.viewOurPrivacyNotice),
            url: "https://www.wayflyer.com/privacy-notice",
          },
        }}
      />
    </>
  );
};
